import { render, staticRenderFns } from "./unmatched-shops-layout.vue?vue&type=template&id=783bba94&scoped=true"
import script from "./unmatched-shops-layout.vue?vue&type=script&lang=js"
export * from "./unmatched-shops-layout.vue?vue&type=script&lang=js"
import style0 from "./unmatched-shops-layout.vue?vue&type=style&index=0&id=783bba94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783bba94",
  null
  
)

export default component.exports